import keys from "lodash/fp/keys";
import capitalize from "lodash/fp/capitalize";

class SlackFormatter {
  format(title, description, data) {
    const initialData = {
      title,
      description,
      type: "Bug",
      category: "Dashboard",
      priority: 1,
    };
    const extra = this.formatRefs(data);

    return Object.assign(initialData, extra);
  }

  formatRefs(data) {
    const dataKeys = keys(data);
    const mapData = (key) => {
      const value = data[key];

      return {
        displayTitle: capitalize(key),
        displayValue: value,
        type: "META",
      };
    };

    const refs = dataKeys.map(mapData);

    return { refs };
  }
}

export default SlackFormatter;



// WEBPACK FOOTER //
// ./src/services/slackFormatter/slackFormatter.service.js